<template>
  <div ref="dashboardsuperset" class="dashboard-app--container-superset">
    <loading-state
      v-if="loading"
      :message="$t('DASHBOARD_APPS.LOADING_MESSAGE')"
    />
    <div v-else-if="errorMessage" class="column">
      <empty-state :title="errorMessage" />
    </div>
  </div>
</template>

<script>
import LoadingState from 'dashboard/components/widgets/LoadingState';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import { mapGetters } from 'vuex';
import EmptyState from 'dashboard/components/widgets/EmptyState';

export default {
  components: {
    LoadingState,
    EmptyState,
  },
 
  props: {        
      supersetId: {
        type: String,
        required: true
      },
      urlParams: {
        type: Object,
        required: false,
        default: () => ({}) 
      }
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
    }),
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loading = true;
      this.errorMessage = null;
      axios
        .post(
          `/api/v1/accounts/${this.accountId}/dashboard_apps/${this.supersetId}/superset/guest-token`,
          {
            dashboard_id: this.supersetId
          }
        )
        .then(({ data }) => {
          this.loading = false;
          embedDashboard({
            id: this.supersetId,
            supersetDomain: 'https://superset.phonetrack.com.br',
            mountPoint: this.$refs.dashboardsuperset,
            fetchGuestToken: () => data.token,
            dashboardUiConfig: {
              hideTitle: true,
              filters: {
                visible: true,
                expanded: false,
              },
              urlParams: {
                ...this.urlParams,
                account_id: this.accountId,
                lista_usuarios: this.currentUser.email
              },
            },
          });
        })
        .catch(error => {
          this.loading = false;
          this.errorMessage = this.$t('DASHBOARD_APPS.ERROR_FETCH');
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss">

.dashboard-app--container-superset{
  height: 100%;
  width: 100%;
}
</style>